module.exports = __webpack_public_path__ + "img/botox.66fcbea5.jpg";